export interface BreadcrumbItemData {
  label: string;
  href?: string; // undefined for current page (last item)
}

/** Type-safe accessor for entityName from location state (passed via DataTable row navigation). */
interface BreadcrumbLocationState {
  entityName?: string;
}
export const getEntityName = (state: unknown): string | undefined =>
  (state as BreadcrumbLocationState)?.entityName;

/** Internal stack entry, keyed by pathname */
export interface BreadcrumbStackEntry {
  pathname: string;
  label: string;
  /** If true, this entry won't be rendered as a clickable link in the breadcrumb trail.
   *  Use for section headers whose pathname has no index route (e.g. /settings). */
  noLink?: boolean;
}

export interface BreadcrumbContextValue {
  items: BreadcrumbItemData[];
  setItems: (items: BreadcrumbItemData[]) => void;
  push: (item: BreadcrumbItemData) => void;
  /** Stack-based push: push/truncate based on pathname.
   *  defaultParents are seeded only when the stack is empty (deep link / reload).
   *  truncateTo: if set, truncate to this pathname before pushing (for tab navigation). */
  pushBreadcrumb: (
    entry: BreadcrumbStackEntry,
    defaultParents?: BreadcrumbStackEntry[],
    truncateTo?: string
  ) => void;
  /** Clear the breadcrumb stack */
  resetStack: () => void;
  /** Programmatically clear all breadcrumbs (e.g. on logout or error boundary reset) */
  clear: () => void;
}
